import IndexPage from "../Crud/IndexPage";
const Instructions = () => {

    const mainPath = "/help"
    return (
        <IndexPage
            title="Hilfe"
            items={[
                { text: "Benutzeroberfläche", path: `${mainPath}/ui` },
                { text: "Kassenterminal", path: `${mainPath}/` },
                { text: "Küchenterminal", path: `${mainPath}/kitchen` },
                { text: "Statistiken", path: `${mainPath}/statistic` },
                { text: "Einstellungen", path: `${mainPath}/settings` },
            ]}
        />
    )
}
export default Instructions;